import { EthnicKey, EthnicKeySEO, EthnicKeyMasgustoSEO } from '@/types/landing';

export const ETHNIC_LIST = [
  EthnicKey.chinese,
  // EthnicKey.mexican,
  EthnicKey.japanese,
  EthnicKey.korean,
  EthnicKey.vietnamese,
  EthnicKey.filipino,
  EthnicKey.indian,
  EthnicKey.asian
];

export const ETHNIC_LIST_SEO = [
  EthnicKeySEO.chinese,
  EthnicKeySEO.japanese,
  EthnicKeySEO.korean,
  EthnicKeySEO.vietnamese,
  EthnicKeySEO.filipino,
  EthnicKeySEO.indian,
  EthnicKeySEO.thai
];

export const ETHNIC_LIST_SEO_MASGUSTO = [
  EthnicKeyMasgustoSEO.mexican,
  EthnicKeyMasgustoSEO.brazilian,
  EthnicKeyMasgustoSEO.dominican,
  EthnicKeyMasgustoSEO.puertorican
];

export const ETHNIC_LIST_SEO_MASGUSTO_LANG_ES = [
  EthnicKeyMasgustoSEO.mexican,
  EthnicKeyMasgustoSEO.dominican,
  EthnicKeyMasgustoSEO.puertorican
];

export const ETHNIC_LIST_SEO_MASGUSTO_LANG_PT = [EthnicKeyMasgustoSEO.brazilian];
